import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Loader2 } from 'lucide-react';
import { API_BASE_URL } from './config';
import secureStorage from './utils/secureStorage';
import ICSOrganizationChart from './components/ICSOrganizationChart';

// Read exercise id from the URL hash query, e.g. #display-ics203?exercise=abc
const getExerciseIdFromHash = () => {
  try {
    const raw = (window.location.hash || '').substring(1);
    const q = raw.split('?')[1];
    if (!q) return null;
    const params = new URLSearchParams(q);
    return params.get('exercise') || params.get('exercise_id') || null;
  } catch (_) {
    return null;
  }
};

const DisplayICS203 = () => {
  const exerciseId = getExerciseIdFromHash();
  const [exercise, setExercise] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!exerciseId) { setError('No exercise specified'); setLoading(false); return; }
    (async () => {
      try {
        const token = secureStorage.getToken();
        const resp = await axios.get(`${API_BASE_URL}/api/exercise-builder/${exerciseId}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setExercise(resp.data);
      } catch (e) {
        setError(e.response?.data?.detail || e.message || 'Failed to load exercise');
      } finally {
        setLoading(false);
      }
    })();
  }, [exerciseId]);

  if (loading) {
    return (
      <div className="fixed inset-0 bg-black flex items-center justify-center">
        <Loader2 className="h-16 w-16 text-orange-500 animate-spin" />
      </div>
    );
  }

  if (error || !exercise) {
    return (
      <div className="fixed inset-0 bg-black flex flex-col items-center justify-center text-white gap-3">
        <p className="text-2xl">Unable to load ICS 203</p>
        <p className="text-red-400 text-sm">{error || 'Exercise not found'}</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-black" data-testid="ics203-display-mode">
      <div className="max-w-full mx-auto">
        <div className="text-center py-4">
          <h1 className="text-3xl font-bold text-orange-400">ICS 203 — Organization Assignment List</h1>
          <p className="text-gray-400 text-sm mt-1">{exercise.exercise_name || ''}</p>
        </div>
        <ICSOrganizationChart
          currentExercise={exercise}
          API_URL={API_BASE_URL}
          displayMode
        />
      </div>
    </div>
  );
};

export default DisplayICS203;
